import type { Action } from 'vuex'
import type { Params, State } from './state'
import type { UserInfo } from '@/views/userInfo/user-info-reference/types'

import actionTypes from './actionTypes'
import { getData } from '@/api/user_info/user_info'
import { formatDate } from '@/utils'

const actions: { [actionTypes: string]: Action<State, any> } = {
  [actionTypes.SET_SUER_INFO_DETAIL]: async ({ commit, state }): Promise<void> => {
    // 利用者情報一覧取得
    const result = await getData(state.userParams)
    if (result.data.detail.length > 0) {
      result.data.detail.forEach((item: any) => {
        item.insert_datetime = formatDate(item.insert_datetime)
      })
    }
    const data = result.data.detail

    commit(actionTypes.SET_SUER_INFO_DETAIL, data)
    commit(actionTypes.SET_TOTAL_COUNT, result.data.total_count)
  },

  // 利用者参照画面ユーザーインフォメーション
  [actionTypes.SET_USER_INFO_ITEM]: ({ commit }, item: UserInfo): void => {
    commit(actionTypes.SET_USER_INFO_ITEM, item)
  },
  // 利用者参照画面編集モードステータス
  [actionTypes.SET_EDIT_MODEL_STATUS]: ({ commit }, status: boolean): void => {
    commit(actionTypes.SET_EDIT_MODEL_STATUS, status)
  },
  // 利用者新規画面編集モードステータス
  [actionTypes.SET_ADD_MODEL_STATUS]: ({ commit }, status: boolean): void => {
    commit(actionTypes.SET_ADD_MODEL_STATUS, status)
  },

  [actionTypes.SET_PARAMS]: ({ commit }, params: Params): void => {
    commit(actionTypes.SET_PARAMS, params)
  },
}

export default actions
